import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import RestaurantDigitalTransformationLandingPage from "pages/restaurant-digital-transformation-landing-page";
import NotFound from "pages/NotFound";
import PrivacyPolicyPage from "pages/PrivacyPolicyPage";
import TermsOfServicePage from "pages/TermsOfServicePage";
import CookiePolicyPage from "pages/CookiePolicyPage";
import KVKKPage from "pages/KVKKPage";
import RefundPolicyPage from "pages/RefundPolicyPage";
import SLAPage from "pages/SLAPage";
import FranchisePage from "pages/FranchisePage";
import DownloadPage from "pages/DownloadPage";
import CafeSolutionPage from "pages/solutions/CafeSolutionPage";
import RestaurantSolutionPage from "pages/solutions/RestaurantSolutionPage";
import FastFoodSolutionPage from "pages/solutions/FastFoodSolutionPage";
import DonerSolutionPage from "pages/solutions/DonerSolutionPage";
import BakerySolutionPage from "pages/solutions/BakerySolutionPage";
import ChainSolutionPage from "pages/solutions/ChainSolutionPage";
import QRMenuPage from "pages/modules/QRMenuPage";
import QROrderPage from "pages/modules/QROrderPage";
import OnlineOrderPage from "pages/modules/OnlineOrderPage";
import POSSystemPage from "pages/modules/POSSystemPage";
import CourierSystemPage from "pages/modules/CourierSystemPage";
import LoyaltyPage from "pages/modules/LoyaltyPage";
import AccountManagementPage from "pages/modules/AccountManagementPage";
import AISystemPage from "pages/modules/AISystemPage";
import WhatsappOrderPage from "pages/modules/WhatsappOrderPage";
import ModulesIndexPage from "pages/modules/ModulesIndexPage";
import SolutionsIndexPage from "pages/solutions/SolutionsIndexPage";

/**
 * Rehber sayfaları GEÇ yükleniyor (`lazy`).
 *
 * Rehberin tamamı derleme anında HTML'e çevrilip pakete giriyor; statik
 * içe aktarılsaydı her rehber sayfası ANA pakete eklenir ve vitrine ilk
 * giren ziyaretçi hiç açmayacağı onlarca sayfayı da indirirdi. Bu paket
 * 2.307 kB'den 1.289 kB'ye yeni indirildi; rehberin onu geri şişirmemesi
 * için içerik kendi parçasında duruyor.
 */
const GuideIndexPage = lazy(() => import("pages/guide/GuideIndexPage"));
const GuideArticlePage = lazy(() => import("pages/guide/GuideArticlePage"));
// AR sayfası da GEÇ yükleniyor: 3D görüntüleyici (~1 MB) yalnızca bu sayfada
// gerekiyor ve ana paketin geri şişmemesi gerekiyor.
const ArMenuPage = lazy(() => import("pages/ArMenuPage"));

const GuideFallback = () => (
  <div className="min-h-screen flex items-center justify-center">
    <p className="font-open-sans text-text-secondary">Rehber yükleniyor…</p>
  </div>
);

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<RestaurantDigitalTransformationLandingPage />} />
        <Route path="/restaurant-digital-transformation-landing-page" element={<RestaurantDigitalTransformationLandingPage />} />
        
        {/* Legal Pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/kvkk" element={<KVKKPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="/sla" element={<SLAPage />} />
        <Route path="/franchise" element={<FranchisePage />} />
        {/* Kasa uygulaması (apps/desktop) — paketler R2'de, sayfa release.json okuyor */}
        <Route path="/download" element={<DownloadPage />} />

        {/* Solutions Pages */}
        <Route path="/solutions/cafe" element={<CafeSolutionPage />} />
        <Route path="/solutions/restaurant" element={<RestaurantSolutionPage />} />
        <Route path="/solutions/fastfood" element={<FastFoodSolutionPage />} />
        <Route path="/solutions/doner" element={<DonerSolutionPage />} />
        <Route path="/solutions/bakery" element={<BakerySolutionPage />} />
        <Route path="/solutions/chain" element={<ChainSolutionPage />} />
        <Route path="/solutions" element={<SolutionsIndexPage />} />

        {/* Module Pages */}
        <Route path="/moduller" element={<ModulesIndexPage />} />
        <Route path="/qr-menu" element={<QRMenuPage />} />
        <Route path="/qr-order" element={<QROrderPage />} />
        <Route path="/online-order" element={<OnlineOrderPage />} />
        <Route path="/pos-system" element={<POSSystemPage />} />
        <Route path="/courier-system" element={<CourierSystemPage />} />
        <Route path="/loyalty" element={<LoyaltyPage />} />
        <Route path="/cari-finans" element={<AccountManagementPage />} />
        <Route path="/ai-system" element={<AISystemPage />} />
        <Route path="/whatsapp-order" element={<WhatsappOrderPage />} />
        <Route
          path="/ar-menu"
          element={
            <Suspense fallback={<div className="min-h-screen bg-gray-950" />}>
              <ArMenuPage />
            </Suspense>
          }
        />

        {/* Kullanım Rehberi — içeriğiyle birlikte AYRI parçaya bölünüyor (aşağıdaki
            not). Yol İngilizce: /moduller ve /cari-finans eski kalıntı, örnek değil. */}
        <Route
          path="/guide"
          element={
            <Suspense fallback={<GuideFallback />}>
              <GuideIndexPage />
            </Suspense>
          }
        />
        <Route
          path="/guide/:slug"
          element={
            <Suspense fallback={<GuideFallback />}>
              <GuideArticlePage />
            </Suspense>
          }
        />

        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;